module.exports = __webpack_public_path__ + "static/media/ico_calendario.3f4a9ff3.svg";